import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axios';

export const fetchProfile = createAsyncThunk(
  'profile/fetchProfile',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state: any = getState();

      // Try to get token from Redux state first
      let token = state.auth.token;

      // If no token in Redux state, try to get it from cookies
      if (!token) {
        const cookies = document.cookie.split('; ');

        // Check for admin token
        const adminCookie = cookies.find(cookie => cookie.startsWith('pms_admin_='));
        if (adminCookie) {
          token = adminCookie.split('=')[1];
        }

        // If no admin token, check for employee token
        if (!token) {
          const employeeCookie = cookies.find(cookie => cookie.startsWith('pms_employee_='));
          if (employeeCookie) {
            token = employeeCookie.split('=')[1];
          }
        }
      }

      if (!token) {
        throw new Error('Authentication token is missing');
      }

      // Determine user type from cookies if not available in state
      let userType = state.auth.user?.designation;

      if (!userType) {
        // Check which cookie exists to determine user type
        const hasAdminCookie = document.cookie.includes('pms_admin_=');
        const hasEmployeeCookie = document.cookie.includes('pms_employee_=');

        // Default to employee profile endpoint if employee cookie exists
        if (hasEmployeeCookie) {
          userType = 'employee';
        } else if (hasAdminCookie) {
          userType = 'superAdmin';
        } else {
          throw new Error('User type could not be determined');
        }
      }

      // Choose the right API endpoint based on user type
      const url =
        userType === 'superAdmin' || userType === 'admin' ? '/admin/profile' : '/employee/profile';
      const response = await axiosInstance.get(`/v1${url}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Log the response to verify manager data
      if (response.data?.data?.manager) {
        console.log('Manager data retrieved:', response.data.data.manager);
      }

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message || 'An error occurred');
    }
  }
);
